import {VerificationMethod} from '/src/com/yext/listingslaunchstorm/js/data/verificationmethod';

/**
 * @fileoverview Model representing a Verified Listing.
 *
 * @author Kuber Sethi(ksethi@yext.com)
 */
export class VerifiedListing {
  /**
   * @param {{
   *  entityId: number,
   *  method: VerificationMethod,
   * }} params
   */
  constructor(params) {
    /** @type {number} */
    this.entityId = params.entityId;
    /** @type {string} */
    this.method = params.method;
  }
}
